import React from 'react';

export const CountryConfigContext = React.createContext({ config: [] });
